import { useCallback } from 'react';

import useEnum from '@hooks/useEnum';

import OrigemService from '@services/OrigemService';

const useOrigens = () => {
    const fetch = useCallback(() => OrigemService.listar(), []);
    const { data, loading, error } = useEnum(fetch);

    return { data, loading, error };
}

export default useOrigens;